import React, { useCallback, useEffect, useRef, useState } from "react";
import FxDashboard from "./components/FxDashBoard";
import * as authAction from "./jwt/auth-action";

import { FxmsData } from "./datas/FxData";
import { FxUiData } from "./datas/FxUiData";
import { FxAlert, FxConfirm, FxWindow } from "./windows/FxWindows";
import DashboardAdmin from "./admin/DashboardAdmin";
import jwt_decode from "jwt-decode";
import { GadgetDashboard } from "./components/GadgetDashboard";
import AdminTabLayout from "./admin/AdminTabLayout";

let logoutTimer;

const FxmsAPP = (props) => {
  const { uiGrpNo, userGrpNo } = props;
  const snackbar = React.useRef(null);
  const fxConfirm = React.useRef(null);
  const [init, setInit] = React.useState(false);
  const [userNo, setUserNo] = useState(
    jwt_decode(localStorage.getItem("token")).userNo
  );

  useEffect(() => {
    FxWindow.setSnackbar(snackbar);
    FxWindow.setFxConfirm(fxConfirm);
    FxUiData.initBaseComp();
    FxmsData.initData(function (obj) {
      console.log("*** FxmsAPP *** initData = ", obj);
      setInit(true);
    });
  }, []);

  const logoutHandler = useCallback(() => {
    authAction.logoutActionHandler();
    FxmsData.logout();

    if (logoutTimer) {
      clearTimeout(logoutTimer);
    }
  }, []);

  // logoutTimer = setTimeout(
  //   logoutHandler,
  //   localStorage.getItem("remainingTime")
  // );

  console.log("*** FxmsAPP *** uiGrpNo = ", props.uiGrpNo);
  console.log("*** FxmsAPP *** init = ", init);

  if (init === false) {
    return "";
  }

  return (
    <>
      {/*<GadgetDashboard dashbNo={2} editable={false}/>*/}
      {uiGrpNo >= 0 ? <FxDashboard uiGrpNo={uiGrpNo} userGrpNo={userGrpNo} /> : ""}
      {userNo === 2 ? <AdminTabLayout uiGrpNo={uiGrpNo} userNo={userNo} userGrpNo={userGrpNo} /> : ""}
      <FxAlert snackbar={snackbar} />
      <FxConfirm fxConfirm={fxConfirm} />
    </>
  );
};

export default FxmsAPP;
